import { HttpClient } from "@angular/common/http";
import { Component, OnChanges, OnInit, SimpleChanges } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import * as moment from "moment";
import { finalize, take } from "rxjs/operators";

@Component({
  selector: "app-root-contentment-survey",
  templateUrl: "./root-contentment-survey.component.html",
  styleUrls: ["./root-contentment-survey.component.scss"],
})
export class RootContentmentSurveyComponent implements OnInit {
  company: any;
  companyId: string;

  categoryUserTypes = [
    { label: "Kullanıcı", value: "KK" },
    { label: "Pasif Kategori Kullanıcısı", value: "KP" },
    { label: "Kullanıcı Değil", value: "KD" },
  ];

  categoryUserTypesSecondary = [
    { label: "Potansiyel Kategori Kullanıcısı", value: "KPO" },
    { label: "Kategoriyi Reddeden Kullanıcı", value: "KR" },
  ];

  brandUserTypes = [
    { label: "Durumsal Müşteri", value: "D" },
    { label: "Sadık Müşteri", value: "S" },
    { label: "Potansiyel Müşteri", value: "MP1" },
    { label: "Pasif Müşteri", value: "MPA" },
  ];

  notBrandUserTypes = [
    { label: "Potansiyel Müşteri", value: "MP2" },
    { label: "Markayı Reddeden", value: "MR" },
  ];

  singleAnswerTables: any[] = [
    {
      title: "Kategori",
      variable: '"Kategori"',
      answer: "",
    },
    {
      title: "Marka Adı",
      variable: '"Marka"',
      answer: "",
    },
    {
      title: "Süre",
      variable: '"Süre"',
      answer: "",
    },
  ];

  multipleAnswerTables: any[] = [
    {
      title: "Ne Sıklıkla Alışveriş Yaptığı",
      questionNumber: "0",
      variable: '"Alışveriş Sıklığı"',
      hideBrand: true,
      answers: [
        { answer: "", categoryUserType: "" },
        { answer: "", categoryUserType: "" },
        { answer: "", categoryUserType: "" },
        { answer: "", categoryUserType: "" },
        { answer: "", categoryUserType: "" },
        { answer: "", categoryUserType: "" },
        { answer: "", categoryUserType: "" },
        { answer: "", categoryUserType: "" },
        { answer: "", categoryUserType: "" },
        {
          answer: "Hiç tüketmedim",
          categoryUserType: "",
        },
      ],
    },
    {
      title: "Ne Sıklıkla Alışveriş Yaptığı M",
      questionNumber: "1",
      variable: '"Alışveriş Sıklığı M"',
      copyAnswersFromQuestionNumber: "0",
      answers: [
        { answer: "", categoryUserType: "KK veya KP", brandUserType: "" },
        { answer: "", categoryUserType: "KK veya KP", brandUserType: "" },
        { answer: "", categoryUserType: "KK veya KP", brandUserType: "" },
        { answer: "", categoryUserType: "KK veya KP", brandUserType: "" },
        { answer: "", categoryUserType: "KK veya KP", brandUserType: "" },
        { answer: "", categoryUserType: "KK veya KP", brandUserType: "" },
        { answer: "", categoryUserType: "KK veya KP", brandUserType: "" },
        { answer: "", categoryUserType: "KK veya KP", brandUserType: "" },
        { answer: "", categoryUserType: "KK veya KP", brandUserType: "" },
        {
          answer: "Hiç tüketmedim",
          categoryUserType: "KD",
          brandUserType: "",
        },
      ],
    },
    {
      title: "Kategori Tercih Etmeme Sebepleri",
      questionNumber: "0.1",
      variable: '"Kategori Değil"',
      hideBrand: true,
      showCategoryUserTypeSecondary: true,
      answers: [
        { answer: "", categoryUserType: "" },
        { answer: "", categoryUserType: "" },
        { answer: "", categoryUserType: "" },
        {
          answer: "Kullandım ama memnun kalmadım.",
          categoryUserType: "",
        },
        { answer: "", categoryUserType: "" },
        { answer: "", categoryUserType: "" },
        { answer: "", categoryUserType: "" },
        { answer: "", categoryUserType: "" },
        { answer: "Diğer", categoryUserType: "" },
      ],
    },
    {
      title: "Rakipler",
      questionNumber: "0.1.1",
      variable: '"Rakip Marka M"',
      hideCatBrand: true,
      copyAnswersFromQuestionNumber: "1.8",
      answers: [
        {
          answer: '"Marka"',
          categoryUserType: "KK",
          brandUserType: "",
          copyDisabled: true,
        },
        { answer: "", categoryUserType: "KK", brandUserType: "" },
        { answer: "", categoryUserType: "KK", brandUserType: "" },
        { answer: "", categoryUserType: "KK", brandUserType: "" },
        { answer: "", categoryUserType: "KK", brandUserType: "" },
        { answer: "", categoryUserType: "KK", brandUserType: "" },
        { answer: "", categoryUserType: "KK", brandUserType: "" },
        { answer: "", categoryUserType: "KK", brandUserType: "" },
        { answer: "", categoryUserType: "KP", brandUserType: "" },
        { answer: "", categoryUserType: "KD", brandUserType: "" },
      ],
    },
    {
      title: "Marka Pasif Müşteri Olma Sebepleri",
      questionNumber: "1.6",
      variable: '"Marka Pasif"',
      hideBrand: true,
      hideCatBrand: true,
      answers: [
        { answer: "", categoryUserType: "KK" },
        { answer: "", categoryUserType: "KK" },
        {
          answer: '"Marka" ile ilgili sorun yaşadım',
          categoryUserType: "KK",
        },
        { answer: "", categoryUserType: "KK" },
        { answer: "", categoryUserType: "KK" },
        { answer: "", categoryUserType: "KK" },
        { answer: "", categoryUserType: "KK" },
        { answer: "", categoryUserType: "KK" },
        { answer: "", categoryUserType: "KP" },
        { answer: "", categoryUserType: "KD" },
      ],
    },

    {
      title: "Marka Tercih Etmeme Sebepleri",
      questionNumber: "1.7",
      variable: '"Marka Değil"',

      showNotBrand: true,
      answers: [
        { answer: "", categoryUserType: "KK", brandUserType: "" },
        { answer: "", categoryUserType: "KK", brandUserType: "" },
        {
          answer: "Daha önce kullandım ama memnun kalmadım.",
          categoryUserType: "KK",
          brandUserType: "",
        },
        { answer: "", categoryUserType: "KK", brandUserType: "" },
        { answer: "", categoryUserType: "KK", brandUserType: "" },
        { answer: "", categoryUserType: "KK", brandUserType: "" },
        { answer: "", categoryUserType: "KK", brandUserType: "" },
        { answer: "", categoryUserType: "KK", brandUserType: "" },
        { answer: "", categoryUserType: "KP", brandUserType: "" },
        { answer: "", categoryUserType: "KP", brandUserType: "" },
      ],
    },
    {
      title: "Rakipler",
      questionNumber: "1.6.2,1.8",
      variable: '"Rakip Markalar"',
      hideCatBrand: true,
      answers: [
        {
          answer: "",
          categoryUserType: "KK",
          brandUserType: "",
        },
        { answer: "", categoryUserType: "KK", brandUserType: "" },
        { answer: "", categoryUserType: "KK", brandUserType: "" },
        { answer: "", categoryUserType: "KK", brandUserType: "" },
        { answer: "", categoryUserType: "KK", brandUserType: "" },
        { answer: "", categoryUserType: "KK", brandUserType: "" },
        { answer: "", categoryUserType: "KK", brandUserType: "" },
        { answer: "", categoryUserType: "KK", brandUserType: "" },
        { answer: "", categoryUserType: "KP", brandUserType: "" },
        { answer: "", categoryUserType: "KD", brandUserType: "" },
      ],
    },
    {
      title: "Beklentiler/memnuniyet",
      questionNumber: "0.0.1,1.1,1.3,1.8.1,1.6.2.1,1.6.2.2",
      variable: '"Sektör Beklentileri"',
      hideCatBrand: true,
      valueCount: 2,
      answers: [
        { answer: "", categoryUserType: "", brandUserType: "" },
        { answer: "", categoryUserType: "", brandUserType: "" },
        { answer: "", categoryUserType: "", brandUserType: "" },
        { answer: "", categoryUserType: "", brandUserType: "" },
        { answer: "", categoryUserType: "", brandUserType: "" },
        { answer: "", categoryUserType: "", brandUserType: "" },
        { answer: "", categoryUserType: "", brandUserType: "" },
        { answer: "", categoryUserType: "", brandUserType: "" },
        { answer: "", categoryUserType: "", brandUserType: "" },
        { answer: "Diğer", categoryUserType: "", brandUserType: "" },
      ],
    },
    {
      hidden: true,
      title: "Cinsiyet",
      questionNumber: "-4",
      answers: [
        { answer: "Kadın", categoryUserType: "" },
        { answer: "Erkek", categoryUserType: "" },
        { answer: "Belirtmek istemiyorum", categoryUserType: "" },
      ],
    },
    {
      hidden: true,
      title: "Yaş",
      questionNumber: "-3",
      answers: [
        { answer: "18 – 24 yaş arasında", categoryUserType: "" },
        { answer: "25 – 34 yaş arasında", categoryUserType: "" },
        { answer: "35 – 44 yaş arasında", categoryUserType: "" },
        { answer: "45 – 54 yaş arasında", categoryUserType: "" },
        { answer: "55 – 65 yaş arasında", categoryUserType: "" },
        { answer: "65’den büyük", categoryUserType: "" },
      ],
    },
    {
      hidden: true,
      title: "Çalışma Durumu",
      questionNumber: "-2",
      answers: [
        { answer: "Öğrenciyim", categoryUserType: "" },
        { answer: "Kamuda ücretli çalışıyorum", categoryUserType: "" },
        { answer: "Özel sektörde ücretli çalışıyorum", categoryUserType: "" },
        { answer: "Kendi hesabıma çalışıyorum", categoryUserType: "" },
        { answer: "Çalışmıyorum ama iş arıyorum", categoryUserType: "" },
        { answer: "Çalışmıyorum, iş de aramıyorum", categoryUserType: "" },
        { answer: "Emekliyim", categoryUserType: "" },
      ],
    },
    {
      hidden: true,
      title: "Şehir",
      questionNumber: "-1",
      answers: [
        { answer: "İstanbul", categoryUserType: "" },
        { answer: "Ankara", categoryUserType: "" },
        { answer: "İzmir", categoryUserType: "" },
        { answer: "Bursa", categoryUserType: "" },
        { answer: "Antalya", categoryUserType: "" },
        { answer: "Adana", categoryUserType: "" },
        { answer: "Konya", categoryUserType: "" },
        { answer: "Şanlıurfa", categoryUserType: "" },
        { answer: "Gaziantep", categoryUserType: "" },
        { answer: "Diğer", categoryUserType: "" },
      ],
    },
  ];

  getMultipleAnswerTables() {
    return this.multipleAnswerTables.filter((m) => !m.hidden);
  }

  answerLetters = [
    "a",
    "b",
    "c",
    "d",
    "e",
    "f",
    "g",
    "h",
    "i",
    "j",
    "k",
    "l",
    "m",
    "n",
    "o",
    "p",
    "q",
    "r",
    "s",
    "t",
    "u",
    "v",
    "w",
    "x",
    "y",
    "z",
  ];

  questions = [
    {
      variable: '"Cinsiyet"',
      title: "Cinsiyetiniz?",
      questionNumber: "-4",
    },
    {
      variable: '"Yaş"',
      title: "Yaşınız hangi aralıktadır?",
      questionNumber: "-3",
    },
    {
      variable: '"Çalışma Durumu"',
      title: "Çalışma durumunuzu hangisi en iyi ifade eder?",
      questionNumber: "-2",
    },
    {
      variable: '"Şehir"',
      title: "Hangi şehirde yaşıyorsunuz?",
      questionNumber: "-1",
    },
    {
      variable: '"Alışveriş Sıklığı"',
      title:
        '"Süre" kaç defa "Kategori" kategorisinde ürün/hizmet satın almışsınızdır?',
      questionNumber: "0",
    },
    {
      variable: '"Sektör Beklentileri"',
      title:
        '"Kategori" kategorisinde alışveriş yaparken en çok önem verdiğiniz konular nelerdir?',
      questionNumber: "0.0.1",
      showIfNotLetter: "0:j",
    },
    {
      variable: '"Kategori Değil"',
      title: '"Kategori" kategorisinde neden satın alma yapmıyorsunuz?',
      questionNumber: "0.1",
      showIfLetter: "0:j",
    },
    {
      variable: '"Rakip Marka M"',
      title: "Hangi markaların ürünlerinden memnun kalmadınız?",
      questionNumber: "0.1.1",
      showIfLetter: "0.1:d",
    },
    {
      variable: "",
      title:
        '"Rakip Marka Seçimi" ile ilgili nasıl bir memnuniyetsizlik yaşadınız?',
      questionNumber: "0.1.1.1",
      getRivalBrandFrom: "0.1.1",
    },
    {
      variable: '"Alışveriş Sıklığı M"',
      title:
        '"Süre" kaç defa "Marka" markasının ürünlerini/hizmetlerini tüketmişsinizdir?',
      questionNumber: "1",
      showIfNotLetter: "0:j",
    },
    {
      variable: '"Sektör Beklentileri"',
      title: '"Marka" markasının en beğendiğiniz özellikleri hangileridir?',
      questionNumber: "1.1",
      showIfNotLetter: "1:g,h,j,i",
    },
    {
      variable: "",
      title:
        '"Marka" markasının en beğendiğiniz özelliğini paylaşabilir misiniz?',
      questionNumber: "1.2",
      showIfLetter: "1:g,h",
    },
    {
      variable: '"Sektör Beklentileri"',
      title: 'Elinizde güç olsa "Marka" ile ilgili neyi değiştirirdiniz?',
      questionNumber: "1.3",
      showIfNotLetter: "1:g,h,j",
    },
    {
      variable: "",
      title: 'Elinizde güç olsa "Marka" ile ilgili neyi değiştirirdiniz?',
      questionNumber: "1.4",
      showIfLetter: "1:g,h",
    },
    {
      variable: '"Marka Pasif"',
      title:
        '"Marka" markasının ürünlerini/hizmetlerini uzun bir süredir tercih etmeme sebebiniz nedir?',
      questionNumber: "1.6",
      showIfLetter: "1:i",
    },
    {
      variable: "",
      title: '"Marka" ile ilgili nasıl bir sorun yaşadınız?',
      questionNumber: "1.6.1",
      showIfLetter: "1.6:c",
    },
    {
      variable: '"Rakip Markalar"',
      title: "Hangi markayı tercih etmeye başladınız?",
      questionNumber: "1.6.2",
      showIfLetter: "1.6:d",
    },
    {
      variable: '"Sektör Beklentileri"',
      title:
        '"Rakip Marka Seçimi" markasının en beğendiğiniz özellikleri hangileridir?',
      questionNumber: "1.6.2.1",
      getRivalBrandFrom: "1.6.2",
    },
    {
      variable: '"Sektör Beklentileri"',
      title:
        'Elinizde güç olsa "Rakip Marka Seçimi" ile ilgili neleri değiştirirdiniz?',
      questionNumber: "1.6.2.2",
      getRivalBrandFrom: "1.6.2",
    },
    {
      variable: '"Marka Değil"',
      title:
        '"Marka" markasının ürün/hizmetlerini tercih etmemenizin en temel sebebi nedir?',
      questionNumber: "1.7",
      showIfLetter: "1:j",
    },
    {
      variable: "",
      title: "Nasıl bir memnuniyetsizlik yaşadınız?",
      questionNumber: "1.7.1",
      showIfLetter: "1.7:c",
    },
    {
      variable: '"Rakip Marka P"',
      title:
        '"Kategori" alışverişleri en çok hangi markayı tercih ediyorsunuz?',
      questionNumber: "1.8",
      showIfLetter: "1:j",
    },
    {
      variable: '"Sektör Beklentileri"',
      title:
        '"Rakip Marka Seçimi" markasının en beğendiğiniz özellikleri hangileridir?',
      questionNumber: "1.8.1",
      showIfNotLetter: "1.8:a",
      getRivalBrandFrom: "1.8",
    },
    {
      variable: '"Sektör Beklentileri"',
      title:
        'Elinizde güç olsa "Rakip Marka Seçimi" ile ilgili neleri değiştirirdiniz?',
      questionNumber: "1.8.2",
      showIfLetter: "1.8:b",
      getRivalBrandFrom: "1.8",
    },
  ];

  generatedQuestions = [];

  latestContentmentSurveyLoading = false;

  constructor(private http: HttpClient, private route: ActivatedRoute) {}

  ngOnInit(): void {
    this.companyId = this.route.snapshot.paramMap.get("id");
    this.http
      .get(`/getCompany/${this.companyId}`)
      .pipe(take(1))
      .subscribe((res: any) => {
        this.company = res;
      });
  }

  onAnswerChange() {
    for (const table of this.multipleAnswerTables) {
      if (!table.copyAnswersFromQuestionNumber) {
        continue;
      }

      const copyFromTable = this.multipleAnswerTables.find((m) =>
        m.questionNumber
          .split(",")
          .includes(table.copyAnswersFromQuestionNumber)
      );
      if (!copyFromTable) {
        continue;
      }

      for (let i = 0; i < table.answers.length; i++) {
        if (table.answers[i].copyDisabled) {
          continue;
        }
        table.answers[i].answer = copyFromTable.answers[i].answer.toString();
      }
    }
  }

  addAnswer(table: any) {
    table.answers.push({
      answer: "",
      categoryUserType: "KK",
      brandUserType: "D",
    });
  }

  deleteAnswer(table: any, index: number) {
    table.answers.splice(index, 1);
  }

  generateQuestions() {
    this.generatedQuestions = [];

    for (const q of this.questions) {
      const multipleAnswerTable = this.multipleAnswerTables.find(
        (m) =>
          m.questionNumber.split(",").includes(q.questionNumber) ||
          m.variable === q.variable
      );

      if (q.getRivalBrandFrom) {
        const rivalBrandQuestion = this.generatedQuestions.find(
          (m) => m.questionNumber === q.getRivalBrandFrom
        );
        if (rivalBrandQuestion) {
          for (let i = 0; i < rivalBrandQuestion.answers.length; i++) {
            const rivalBrand = rivalBrandQuestion.answers[i];
            if (rivalBrand.answer === "Diğer") {
              continue;
            }

            if (rivalBrand.answer) {
              this.generatedQuestions.push({
                variable: q.variable,
                title: q.title.replace(
                  '"Rakip Marka Seçimi"',
                  rivalBrand.answer
                ),
                questionNumber: `${q.questionNumber}.1${i}`,
                answers: multipleAnswerTable?.answers || [],
                showIfLetter: `${rivalBrandQuestion.questionNumber}:${this.answerLetters[i]}`,
                isOpenEnded: !multipleAnswerTable,
                userAnswer: "",
                valueCount: multipleAnswerTable?.valueCount,
              });
            }
          }
        }
      } else {
        this.generatedQuestions.push({
          variable: q.variable,
          title: q.title,
          questionNumber: q.questionNumber,
          answers: multipleAnswerTable?.answers || [],
          showIfNotLetter: q.showIfNotLetter,
          showIfLetter: q.showIfLetter,
          isOpenEnded: !multipleAnswerTable,
          userAnswer: "",
          valueCount: multipleAnswerTable?.valueCount,
        });
      }
    }

    for (const q of this.generatedQuestions) {
      for (let i = 0; i < q.answers.length; i++) {
        const answer = q.answers[i];
        if (answer.answer === "Diğer") {
          this.generatedQuestions.push({
            variable: "",
            title: q.title,
            questionNumber: `${q.questionNumber}.D`,
            answers: [],
            showIfLetter: `${q.questionNumber}:${this.answerLetters[i]}`,
            isOpenEnded: true,
            userAnswer: "",
          });
        }
      }
    }

    this.generatedQuestions.sort(
      (a, b) => parseFloat(a.questionNumber) - parseFloat(b.questionNumber)
    );
  }

  replaceVariable(text: string) {
    let newText = text.toString();
    for (const singleAnswerTable of this.singleAnswerTables) {
      if (!singleAnswerTable.answer) {
        continue;
      }
      newText = newText.replace(
        singleAnswerTable.variable,
        singleAnswerTable.answer
      );
    }
    return newText;
  }

  doShow(question: any) {
    if (!question.showIfNotLetter && !question.showIfLetter) {
      return true;
    }

    const [q, a] = (question.showIfNotLetter || question.showIfLetter).split(
      ":"
    );
    const aList = a.split(",");
    const parentQuestion = this.generatedQuestions.find(
      (m) => m.questionNumber === q
    );
    const includes = aList.includes(parentQuestion.userAnswer);
    if (question.showIfNotLetter) {
      return !includes && parentQuestion.userAnswer;
    } else if (question.showIfLetter) {
      return includes && parentQuestion.userAnswer;
    }

    return false;
  }

  fillDemo() {
    for (const singleAnswerTable of this.singleAnswerTables) {
      if (singleAnswerTable.variable === '"Kategori"') {
        singleAnswerTable.answer = "Dayanıklı Tüketim";
      } else if (singleAnswerTable.variable === '"Marka"') {
        singleAnswerTable.answer = "Arçelik";
      } else if (singleAnswerTable.variable === '"Süre"') {
        singleAnswerTable.answer = "Son 1 yılda";
      }
    }

    for (const multipleAnswerTable of this.multipleAnswerTables) {
      multipleAnswerTable.answers.forEach((answer, answerIndex) => {
        if (answer.answer?.indexOf('"') > -1) {
          // Do nothing, don't change answer
        } else if (multipleAnswerTable.questionNumber === "0") {
          if (answerIndex === 0) {
            answer.answer = "1 - 2  defa";
          } else if (answerIndex === 1) {
            answer.answer = "3 – 5 defa";
          } else if (answerIndex === 2) {
            answer.answer = "5 – 7 defa";
          } else if (answerIndex === 3) {
            answer.answer = "8 – 10 defa";
          } else if (answerIndex === 4) {
            answer.answer = "10 – 15 defa";
          } else if (answerIndex === 5) {
            answer.answer = "Ayda birkaç defa";
          } else if (answerIndex === 6) {
            answer.answer = "Haftada birkaç defa";
          } else if (answerIndex === 7) {
            answer.answer = "Hemen hemen her gün";
          } else if (answerIndex === 8) {
            answer.answer = "1 yıldan önce tüketmiştim";
          } else if (answerIndex === 9) {
            answer.answer = "Hiç tüketmedim";
          }
        } else if (multipleAnswerTable.questionNumber === "1") {
          if (answerIndex === 0) {
            answer.answer = "1 - 2  defa";
          } else if (answerIndex === 1) {
            answer.answer = "3 – 5 defa";
          } else if (answerIndex === 2) {
            answer.answer = "5 – 7 defa";
          } else if (answerIndex === 3) {
            answer.answer = "8 – 10 defa";
          } else if (answerIndex === 4) {
            answer.answer = "10 – 15 defa";
          } else if (answerIndex === 5) {
            answer.answer = "Ayda birkaç defa";
          } else if (answerIndex === 6) {
            answer.answer = "Haftada birkaç defa";
          } else if (answerIndex === 7) {
            answer.answer = "Hemen hemen her gün";
          } else if (answerIndex === 8) {
            answer.answer = "1 yıldan önce tüketmiştim";
          } else if (answerIndex === 9) {
            answer.answer = "Hiç tüketmedim";
          }
        } else if (multipleAnswerTable.questionNumber === "0.1") {
          if (answerIndex === 0) {
            answer.answer = "Artık ihtiyacım olmuyor.";
          } else if (answerIndex === 1) {
            answer.answer = "İhtiyaçlarımızı kendim çözümlüyorum.";
          } else if (answerIndex === 2) {
            answer.answer = "Ürünler hakkında bilgi sahibi değilim.";
          } else if (answerIndex === 3) {
            answer.answer = "Kullandım ama memnun kalmadım.";
          } else if (answerIndex === 4) {
            answer.answer = "Ürünlerin sağlığıma zararı dokunuyor.";
          } else if (answerIndex === 5) {
            answer.answer = "Ürünlere güvenmiyorum.";
          } else if (answerIndex === 6) {
            answer.answer = "Ürünlerin faydalı olacağına inanmıyorum.";
          } else if (answerIndex === 7) {
            answer.answer = "Fiyatlar yüksek geldi.";
          } else if (answerIndex === 8) {
            answer.answer = "Diğer";
          }
        } else if (multipleAnswerTable.questionNumber === "1.6") {
          if (answerIndex === 0) {
            answer.answer = "Bu kategoride artık ihtiyacım olmuyor. ";
          } else if (answerIndex === 1) {
            answer.answer = "Bu kategoride ihtiyaçlarımı kendim çözümlüyorum.";
          } else if (answerIndex === 2) {
            answer.answer = '"Marka" ile ilgili sorun yaşadım';
          } else if (answerIndex === 3) {
            answer.answer = "Farklı bir markadan alışveriş yapmaya başladım. ";
          } else if (answerIndex === 4) {
            answer.answer = "Diğer";
          }
        } else if (multipleAnswerTable.questionNumber === "1.7") {
          if (answerIndex === 0) {
            answer.answer = "Marka hakkında fazla bilgi sahibi değilim. ";
          } else if (answerIndex === 1) {
            answer.answer = "Markayı hiç tanımıyorum.";
          } else if (answerIndex === 2) {
            answer.answer = "Daha önce kullandım ama memnun kalmadım.";
          } else if (answerIndex === 3) {
            answer.answer = "Ürün/hizmetleri bana uygun değil.";
          } else if (answerIndex === 4) {
            answer.answer = "Markaya güvenmiyorum.";
          } else if (answerIndex === 5) {
            answer.answer = "Diğer markaları daha iyi buluyorum. ";
          }
        } else if (multipleAnswerTable.questionNumber === "1.6.2,1.8") {
          if (answerIndex === 0) {
            answer.answer = "Beko";
          } else if (answerIndex === 1) {
            answer.answer = "Dyson";
          } else if (answerIndex === 2) {
            answer.answer = "Fakir";
          } else if (answerIndex === 3) {
            answer.answer = "Siemens";
          } else if (answerIndex === 4) {
            answer.answer = "aRZUM";
          } else if (answerIndex === 5) {
            answer.answer = "Vestel";
          } else if (answerIndex === 6) {
            answer.answer = "Bosch";
          } else if (answerIndex === 7) {
            answer.answer = "Grundig";
          } else if (answerIndex === 8) {
            answer.answer = "Electrolux";
          } else if (answerIndex === 9) {
            answer.answer = "LG";
          }
        } else if (
          multipleAnswerTable.questionNumber ===
          "0.0.1,1.1,1.3,1.8.1,1.6.2.1,1.6.2.2"
        ) {
          if (answerIndex === 0) {
            answer.answer = "Ürünlerin kalitesi";
          } else if (answerIndex === 1) {
            answer.answer = "Satış sonrası hizmetler";
          } else if (answerIndex === 2) {
            answer.answer = "Marka imajı";
          } else if (answerIndex === 3) {
            answer.answer = "Ulaşılabilirlik/Bulunurluk";
          } else if (answerIndex === 4) {
            answer.answer = "Reklamlar";
          } else if (answerIndex === 5) {
            answer.answer = "Müşteri hizmetleri";
          } else if (answerIndex === 6) {
            answer.answer = "Fiyatlar";
          } else if (answerIndex === 7) {
            answer.answer = "Ürün çeşitliliği";
          } else if (answerIndex === 8) {
            answer.answer = "Sürdürülebilirlik";
          } else if (answerIndex === 9) {
            answer.answer = "Diğer";
          }
        }

        if (multipleAnswerTable.showCategoryUserTypeSecondary) {
          answer.categoryUserType = this.categoryUserTypesSecondary[0].value;
        } else if (multipleAnswerTable.hideBrand) {
          answer.categoryUserType = this.categoryUserTypes[0].value;
        } else if (multipleAnswerTable.showNotBrand) {
          answer.brandUserType = this.notBrandUserTypes[0].value;
        } else {
          answer.brandUserType = this.brandUserTypes[0].value;
        }
      });
    }

    this.onAnswerChange();
  }

  saveSurvey() {
    if (!confirm("Anketi kaydetmek istediğinize emin misiniz?")) {
      return;
    }

    this.generateQuestions();
    const expireDate = moment().add(30, "d").toDate();

    const requestQuestions = [];
    let index = 0;
    for (const q of this.generatedQuestions) {
      // Parse connection logic from showIfLetter and showIfNotLetter
      let isConnected = null;
      let connectedQuestionIndex = null;
      let connectionOptions = null;

      if (q.showIfLetter || q.showIfNotLetter) {
        const conditionString = q.showIfLetter || q.showIfNotLetter;
        const [parentQuestionNumber, expectedAnswers] =
          conditionString.split(":");

        // Find the parent question index in generatedQuestions
        const parentQuestionIndex = this.generatedQuestions.findIndex(
          (gq) => gq.questionNumber === parentQuestionNumber
        );

        if (parentQuestionIndex !== -1) {
          isConnected = "true"; // Must be string "true" for survey component
          connectedQuestionIndex = parentQuestionIndex;

          // Convert letters to option values (a=1, b=2, c=3, etc.)
          const answerLetters = expectedAnswers.split(",");
          const targetOptions = answerLetters.map((letter) => {
            const letterIndex = this.answerLetters.indexOf(letter.trim());
            return letterIndex !== -1
              ? letterIndex + 1
              : parseInt(letter.trim()) || 1;
          });

          // Get the parent question to determine total options
          const parentQuestion = this.generatedQuestions[parentQuestionIndex];
          const totalOptions = parentQuestion.answers.length;

          if (q.showIfNotLetter) {
            // For "showIfNotLetter", include all options EXCEPT the specified ones
            connectionOptions = [];
            for (let i = 1; i <= totalOptions; i++) {
              if (!targetOptions.includes(i)) {
                connectionOptions.push(i);
              }
            }
          } else {
            // For "showIfLetter", include only the specified options
            connectionOptions = targetOptions;
          }
        }
      }

      requestQuestions.push({
        order: index + 1,
        type: "new",
        kind: q.isOpenEnded ? "open" : "close",
        sort: q.isOpenEnded ? "open" : "multiple",
        shuffleOptions: false,
        isConnected: isConnected,
        connectedQuestionIndex: connectedQuestionIndex,
        connectionOptions: connectionOptions,
        connectedQuestion:
          connectedQuestionIndex !== null
            ? requestQuestions.find(
                (m) => m.order === connectedQuestionIndex + 1
              )
            : null,
        isRelated: "false",
        relatedQuestion: null,
        relatedQuestionIndex: null,
        minimumValue: 0,
        relatedQuestionError: 0,
        question: {
          text: this.replaceVariable(q.title),
          optionCount: q.answers.length,
          options: q.answers
            .filter((answer) => answer.answer)
            .map((answer, i) => ({
              text: this.replaceVariable(answer.answer),
              value: i + 1,
            })),
          valueCount: q.valueCount || 0,
          rangeCount: 10,
        },
        // Keep original condition data for reference
        showIfLetter: q.showIfLetter,
        showIfNotLetter: q.showIfNotLetter,
        questionNumber: q.questionNumber,
        variable: q.variable,
      } as any);

      index++;
    }

    this.http
      .post("/saveSurvey", {
        isContentmentSurvey: true,
        contentmentSurveyDetails: {
          singleAnswerTables: this.singleAnswerTables,
          multipleAnswerTables: this.multipleAnswerTables,
          questions: this.questions,
        },
        companyId: this.companyId,
        campaignDescription: this.replaceVariable(
          '"Marka" Memnuniyet Anketi Kampanya Açıklama'
        ),
        campaignExpireDate: expireDate.toISOString(),
        campaignExpireDateTime: expireDate.getTime(),
        customTimeLimit: false,
        description: this.replaceVariable('"Marka" Memnuniyet Anketi Açıklama'),
        discountAmount: 10,
        discountAmountType: "%",
        discountType: "Indirim",
        name: this.replaceVariable('"Marka" Memnuniyet Anketi'),
        slugUrl: "",
        showOnHomePage: false,
        timeLimit: 15,
        questions: requestQuestions,
      })
      .pipe(take(1))
      .subscribe(
        (res: any) => {
          alert("Anket başarıyla oluşturuldu.");
          window.open(`/${this.companyId}/${res.surveyId}`, "_blank");
        },
        (error) => {
          console.error("Error saving survey:", error);
          // You can add error handling here
        }
      );
  }

  getMultipleAnswerTableTitle(table: any) {
    const title =
      this.questions.find((m) => m.questionNumber === table.questionNumber)
        ?.title || table.title;
    return this.replaceVariable(title);
  }

  multipleAnswerTableToQuestion(table: any) {
    return this.questions.find(
      (m) => m.questionNumber === table.questionNumber
    );
  }

  conditionedQuestions() {
    return this.questions.filter(
      (m) =>
        typeof m.showIfLetter !== "undefined" ||
        typeof m.showIfNotLetter !== "undefined"
    );
  }

  fillFromLatestContentmentSurvey() {
    this.latestContentmentSurveyLoading = true;
    this.http
      .get(`/latest-contentment-survey/${this.companyId}`)
      .pipe(
        take(1),
        finalize(() => {
          this.latestContentmentSurveyLoading = false;
        })
      )
      .subscribe((res: any) => {
        if (res) {
          this.singleAnswerTables =
            res.contentmentSurveyDetails.singleAnswerTables;
          this.multipleAnswerTables =
            res.contentmentSurveyDetails.multipleAnswerTables;
          this.questions = res.contentmentSurveyDetails.questions;
          this.onAnswerChange();
        } else {
          alert("Son memnuniyet anketi bulunamadı!");
        }
      });
  }
}
